import { Route } from '@angular/compiler/src/core';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { forkJoin } from 'rxjs';
import { AuthService } from './auth/auth.service';
import { ApiService } from './core/api.service';
import { SystemService } from './core/system.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  unlockStreak: number = 0;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public authService: AuthService,
    private systemService: SystemService,
    private translateService: TranslateService,
    private apiService: ApiService) { }

  ngOnInit() {
    // this language will be used as a fallback when a translation isn't found in the current language
    this.translateService.setDefaultLang('en');

    this.route.queryParams
      .subscribe(value => {
        const lang = value.lang;
        if(!!lang) {
          this.translateService.use(lang);
        }        
      })

    // setup language to use
    this.translateService.use(this.systemService.language$.value);
  }

  logout() {
    this.authService.logout()      
  }

  navigate() {
    this.systemService.inGameMode$.next(false);
    this.router.navigate(['/dashboard'])
  }

  unlock() {
    const user = this.authService.user$.value;
    if(!user) { return; }

    if(this.unlockStreak < 3) { 
      this.unlockStreak++;
      return;
    }

    // unlock now
    const requests = [...this.unlockKeylessons(), ...this.unlockAdvancedlessons()]

    forkJoin(...requests)
      .subscribe(_ => {
        this.systemService.reload$.next();
      })

  }

  unlockKeylessons() {
    let requests = [];
    const {userid, language_in_use} = this.authService.user$.value;

    const numLessons = Array.from({length: 8}, (_, i) => i + 1);
    numLessons.forEach(lessonId => {
      requests.push(this.apiService.markLessonCompleted(userid, lessonId, language_in_use));
    })

    return requests;
  }
   
  
  unlockAdvancedlessons() {
    let requests = [];
    const {userid, language_in_use} = this.authService.user$.value;

    const numLessons = Array.from({length: 12}, (_, i) => i + 1);
    numLessons.forEach(lessonId => {
      requests.push(this.apiService.markAdvancedLessonCompleted(userid, lessonId, language_in_use));
    })

    return requests;
  }

}
